<template>
  <select @change="$emit('update:modelValue', $event.target.value)" :value="modelValue" :disabled="!department">
    <option :value="null">Select a Campaign</option>
    <option v-for="campaign of campaigns" :key="campaign" :value="campaign">{{campaign}}</option>
  </select>
</template>
<script setup lang="ts">
import {
  defineComponent,
  onMounted,
  ref,
  watch,
  computed,
 } from 'vue'

// Define emits for Vue 3
const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()

const props = defineProps<{
  modelValue?: string
  department?: string
  type: string
  required?: any
}>()
const campaigns = ref<
      Array<{
        id: string
        label: string
      }>
    >([])

    watch(
      () => props.department,
      () => {
        if (!props.department) return

        campaigns.value = [
          {
            id: '',
            label: 'Loading',
          },
        ]

        fetch(
          'https://velocity2.ouapis.org/donation-forms/campaigns/' +
            props.department
        )
          .then((x) => x.json())
          .then((result) => (campaigns.value = result))
      },
      {
        immediate: true,
      }
    );
</script>
<style scoped lang="scss">
select {
  border-radius: 4px;
  border: 1px solid #ddd;
  background-color: #f7f9fb;
  color: #222;
  cursor: pointer;
  width: 100%;
  outline: 0;
  box-sizing: border-box;
  min-width: 80px;
  transition: border-color 0.3s ease-in-out;
  font-size: 16px;
  align-items: center;
  box-shadow: none;
  display: inline-flex;
  height: 44px;
  justify-content: flex-start;
  padding: 0 10px;
  position: relative;
  @media only screen and (min-width: 720px) {
    height: 42px;
  }

  &:hover {
    border-color: $color-blue;
  }
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    border: 1px solid #e4e4e4;
    background: #f3f2f2;
  }
  &:focus {
    border-color: $color-blue;
    box-shadow: none;
    color: #222;
    background: white;
    box-shadow: 0 0 3px rgba(56, 93, 163, 0.5);
  }
}
</style>